import { createContext, PropsWithChildren, useContext } from 'react';
import type { Province } from '@billing/validation/payor';

type SiteValidationContextValue = {
  showValidationErrors: boolean;
  province: Province | null;
  setProvince: (province: Province | null) => void;
};

const SiteValidationContext = createContext<SiteValidationContextValue>({
  showValidationErrors: false,
  province: null,
  setProvince: () => undefined,
});

export const SiteValidationProvider = ({
  showValidationErrors,
  province,
  setProvince,
  children,
}: PropsWithChildren<SiteValidationContextValue>) => (
  <SiteValidationContext.Provider
    value={{ showValidationErrors, province, setProvince }}
  >
    {children}
  </SiteValidationContext.Provider>
);

export const useSiteValidationState = () => useContext(SiteValidationContext);
